module.exports = __webpack_public_path__ + "img/twitter-seeklogo.com.c4f438fa.svg";